module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9j2qm"))).then(() => parcelRequire('hEqeo'));